import { LitElement, html, TemplateResult } from 'lit';
import { property, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { CardWidthValues } from '../types';
import { isEmpty } from '@nestjs/common/utils/shared.utils';
import IconSet from '../../gzIcon/GzIconSet';

export class GzCardWebComponent extends LitElement {
  @property({ attribute: true, reflect: true })
  cardWidth = CardWidthValues.SMALL;

  @property({ type: String, reflect: true })
  name: string;

  @property({ type: String, reflect: true })
  icon: string;

  @property({ type: String, reflect: true })
  tagInformation: string;

  @property({ type: String, reflect: true })
  tagAdditionalInformation: string;

  @state()
  private iconSetInstance: IconSet;

  static get styles() {
    return styles;
  }

  constructor() {
    super();
    this.iconSetInstance = IconSet.getInstance();
  }

  render() {
    return html` <div class="card ${isEmpty(this.icon) ? '' : 'd-flex flex-row'}" slot="card-base">
      ${this.renderIconElement()}
      <div class="content d-flex flex-column">
        <div class="d-flex flex-row tag-container">${this.renderAdditionalInformation()} ${this.renderTag()}</div>
        <div class="card-title" part="title">${this.name}</div>
        <div class="card-menu--content">
          <slot></slot>
        </div>
      </div>
    </div>`;
  }

  private renderIcon() {
    if (isEmpty(this.icon)) {
      return;
    }
    return html`<div class="icon ${this.icon}" part="icon"></div>`;
  }

  private renderIconElement() {
    if (isEmpty(this.icon)) {
      return;
    }

    if (this.iconSetInstance.isSVGIconAvailable(this.icon)) {
      return html`<div class="circle-svg">
        <gz-icon .name="${this.icon}" size="32" color="secondary" part="icon"></gz-icon>
      </div>`;
    } else {
      return html`<span class="icon ${this.icon}" part="icon"></span>`;
    }
  }

  setCustomIconSet(iconSet: TemplateResult) {
    this.iconSetInstance.loadCustomIconSet(iconSet);
  }

  private renderTag() {
    if (isEmpty(this.tagInformation)) {
      return;
    }
    return html`<div class="tag-text">${this.tagInformation}</div>`;
  }

  private renderAdditionalInformation() {
    if (isEmpty(this.tagAdditionalInformation)) {
      return;
    }

    return html`<div class="tag-additional-information d-flex align-items-center">
      ${this.tagAdditionalInformation}
    </div>`;
  }

  public setCardContent(template: HTMLElement) {
    this.innerHTML = '';
    this.appendChild(template);
  }
}
